/* ProductInfoRenderer.js */

"use strict";

class ProductInfoRenderer {
    constructor(model) {
        this._model = model;

        this._rootElem = document.createElement("product-information");
        this._rootElem.component = this._model;

        this._titleEl = document.createElement("h1");
        this._titleEl.innerHTML = "Product Information";
        this._contentContainer  = document.createElement("container-main");
        this._contentContainer.classList.add("content-container");
        this._rootElem.appendChild(this._titleEl);
        this._rootElem.appendChild(this._contentContainer);

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _shutdown() {
        let promArr = [];

        return Promise.all(promArr)
            .then(() => {
                this._unregisterListeners();
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._titleEl = undefined;
            });
    }

    _registerListeners() {
        this._model.on("OrganizationChanged", this._onOrgChange = this._onOrgChange.bind(this));
    }

    _unregisterListeners() {
        this._model.removeListener("OrganizationChanged", this._onOrgChange);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */

    render() {
        return this.model.whenModelIsReady()
            .then((data) => {
                this._contentContainer.innerHTML = "";
                this.renderServerSection(data);
                this.renderModuleSection(data);
            });
    }

    formatDate(dateStr) {
        const date = new Date(dateStr);
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
    }

    renderServerSection(data) {
        const serverEl = document.createDocumentFragment();
        const listEl = document.createElement("ul");
        listEl.innerHTML = `
            <li><span class="label">Name</span><span class="value">${data.instanceName}</span></li>
            <li><span class="label">Version</span><span class="value">${data.version}</span>
            <li><span class="label">Installation Date</span><span class="value">${this.formatDate(data.installDate)}</span>
        `;
        serverEl.appendChild(listEl);
        this._contentContainer.appendChild(this._createSection(serverEl, {
            title: "Server",
            tooltip: "Your Gluware primary server name and version",
            className: "server-group",
            bordered: true
        }));
    }

    renderModuleSection(data) {
        let listItems = "";
        for(let key in data.packageVersions) {
            listItems += `<li><span class="label">${key}</span><span class="value">${data.packageVersions[key]}`;
        }
        const moduleEl = document.createDocumentFragment();
        const listEl = document.createElement("ul");
        listEl.innerHTML = `${listItems}`;
        moduleEl.appendChild(listEl);
        this._contentContainer.appendChild(this._createSection(moduleEl, {
            title: "Modules",
            tooltip: "Installed versions of Gluware modules",
            className: "module-group",
            bordered: true
        }));
    }

    _createSection(content, options = {}) {
        const section = document.createElement("section");
        section.className = options.className || "";
        section.classList.toggle("bordered", !!options.bordered);

        if (options.title) {
            const title = document.createElement("h2");
            title.innerText = options.title;
            title.setAttribute('title',options.tooltip);
            section.appendChild(title);
        }
        section.appendChild(content);
        return section;
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    //TODO Private Render Methods here

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/
    _onOrgChange() {
        this.render();
    }
    _onShutdown() {
        this._shutdown();
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    // TODO - Nobody should be using methods on a Renderer directly so make all these methods private

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = ProductInfoRenderer;
